import {
  FETCH_SYSTEM_TRANSACTION_END,
  FETCH_TRANSACTION_START,
  GLOBAL_FETCH_START,
  GLOBAL_FETCH_SUCCESS,
  SAVE_SYSTEM_TRANSACTION,
  SAVE_SYSTEM_TRANSACTION_PAGE,
  SUCCESSFUL_CODE,
} from "appRedux/constants";
import api from "appRedux/api";
import { handleError } from "appRedux/actions/Common";
import _ from "lodash";
import { config } from "constants/config";

const saveTransactionData = (transactionData) => {
  return {
    type: SAVE_SYSTEM_TRANSACTION,
    payload: transactionData,
  };
};

const transactionPulledPagSuccess = (transactionPag) => {
  return {
    type: SAVE_SYSTEM_TRANSACTION_PAGE,
    payload: transactionPag,
  };
};

export const getSystemTransactionData = (
  whitelabelName,
  otp,
  userEmail,
  start,
  end,
  pageNumber,
  pageSize
) => {
  return (dispatch) => {
    dispatch({ type: GLOBAL_FETCH_START });
    dispatch({ type: FETCH_TRANSACTION_START });

    let url = `report/operator/whitelist/transactions?whitelabel=${whitelabelName}&customerEmail=${userEmail}&otp=${otp}&startDate=${start}&endDate=${end}&pageNo=${pageNumber}&pageSize=${pageSize}`;
    api
      .get(url, null, `${config.tokenUrl}`)
      .then(({ data }) => {
        if (data.status && data.statusCode === SUCCESSFUL_CODE) {
          const transactionData = data.data.content;
          const transactionPag = data.data;
          dispatch(transactionPulledPagSuccess(transactionPag));
          dispatch(saveTransactionData(transactionData));

          dispatch({ type: FETCH_SYSTEM_TRANSACTION_END });
        } else {
          dispatch(
            handleError(
              _.isEmpty(data.message) ? "Network Error" : data.message
            )
          ); // same as "FETCH_ERROR"
        }
        dispatch({ type: GLOBAL_FETCH_SUCCESS });
      })
      .catch((error) => {
        dispatch({ type: GLOBAL_FETCH_SUCCESS });
        dispatch(handleError(error.message)); // same as "FETCH_ERROR"
      });
  };
};

// export const downloadReport = (
//   userEmail,
//   whiteLabelName,
//   otp,
//   startDate,
//   endDate
// ) => {
//   return (dispatch) => {
//     const url = `/report/operator/whitelist/token/download?whitelabel=${whiteLabelName}&customerEmail=${userEmail}&otp=${otp}&startDate=&endDate=`;
//     api
//       .get(url, null, `${config.tokenUrl}`)
//       .then(({ data }) => {
//         const url = window.URL.createObjectURL(new Blob([data]));
//         const link = document.createElement("a");
//         const operatorName = decodeURIComponent(userEmail);
//         link.href = url;
//         const fileName = operatorName + `--${startDate}to${endDate}.csv`;
//         link.setAttribute("download", fileName);
//         document.body.appendChild(link);
//         link.click();
//         link.remove();
//       })
//       .catch((error) => {
//         console.error(error);
//         dispatch(handleError(error.message)); // same as "FETCH_ERROR"
//       });
//   };
// };



export const downloadReport = (
  userEmail,
  whiteLabelName,
  otp,
  startDate,
  endDate
) => {
  return (dispatch) => {
    const sanitizedEmail = encodeURIComponent(userEmail);
    const sanitizedWhiteLabel = encodeURIComponent(whiteLabelName);
    const sanitizedOtp = encodeURIComponent(otp);
    
    const url = `/report/operator/whitelist/token/download?whitelabel=${sanitizedWhiteLabel}&customerEmail=${sanitizedEmail}&otp=${sanitizedOtp}&startDate=${startDate}&endDate=${endDate}`;
    
    api
      .get(url, null, `${config.tokenUrl}`)
      .then(({ data }) => {
        const blob = new Blob([data], { type: "text/csv;charset=utf-8" });
        const downloadUrl = window.URL.createObjectURL(blob);
        
        const link = document.createElement("a");
        link.href = downloadUrl;

        const safeEmail = userEmail.replace(/[^a-zA-Z0-9@._-]/g, '');
        const safeStartDate = startDate.replace(/[^0-9-]/g, '');
        const safeEndDate = endDate.replace(/[^0-9-]/g, '');
        const fileName = `${safeEmail}--${safeStartDate}to${safeEndDate}.csv`;

        link.download = fileName;
        link.style.display = "none";
        link.click(); // ✅ This triggers the download without DOM injection
        URL.revokeObjectURL(downloadUrl); // cleanup
      })
      .catch((error) => {
        console.error(error);
        dispatch(handleError(error.message));
      });
  };
};
